<template>
  <ak-dropdown aria-role="list" position-x="right">
    <template #trigger>
      <ak-button v-if="button" circle single-icon color="transparent">
        <ak-icon type="more-vertical" />
      </ak-button>
      <ak-icon
        v-if="!button"
        type="more-vertical"
        class="mx-tiny cursor-pointer"
        color="primary"
      />
    </template>
    <template #default>
      <ak-dropdown-item aria-role="listitem" has-link>
        <router-link
          :to="{ name: 'automationHistory', params: { id: automation._id } }"
          @click.stop
        >
          {{ $t('History') }}
        </router-link>
      </ak-dropdown-item>
      <ak-dropdown-item aria-role="listitem" @click.stop="clone">
        {{ $t('Clone') }}
      </ak-dropdown-item>
      <ak-dropdown-item
        aria-role="listitem"
        class="color-danger"
        @click.stop.prevent="deleteAutomation"
      >
        {{ $t('Delete') }}
      </ak-dropdown-item>
    </template>
  </ak-dropdown>
</template>

<script>
import { defineComponent, inject } from 'vue'
import Dropdown from '@akerolabs/akero-vue/src/components/dropdown/Dropdown.vue'
import DropdownItem from '@akerolabs/akero-vue/src/components/dropdown/DropdownItem.vue'
import Button from '@akerolabs/akero-vue/src/components/button/Button.vue'
import Icon from '@akerolabs/akero-vue/src/components/icon/Icon.vue'
import RouterLink from '../../../legacy/router/RouterLink.vue'
import { DialogProgrammatic } from '@akerolabs/akero-vue/src/components/dialog'
import { request } from '@akerolabs/akero-vue/src/utils/request'
import { success, error } from '../utils'
export default defineComponent({
  name: 'AutomationActions',
  components: {
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [RouterLink.name]: RouterLink,
  },
  props: {
    /**
     * @type {Object}
     * @description The automation object that the actions will be run against
     */
    automation: {
      type: Object,
      default: undefined,
    },
    /**
     * @type {Boolean}
     * @description Do you want the dropdown trigger to be in a button or as just an icon
     */
    button: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    /**
     * @description Inject the open clone modal function from `AutomationList.vue`
     */
    const openCloneModal = inject('openCloneModal')

    /**
     * @description Inject the fetch automation function from `AutomationList.vue`
     */
    const fetchAutomations = inject('fetchAutomations')

    /**
     * @description Inject the fetch stats function from `AutomationList.vue`
     */
    const fetchStats = inject('fetchStats')

    /**
     * @description open the clone modal for the given automation
     */
    const clone = () => {
      openCloneModal(props.automation)
    }

    /**
     * @description Open the delete modal and run the api request to delete on confirm
     */
    const deleteAutomation = () => {
      DialogProgrammatic.prompt({
        title: 'Delete Automation',
        message: `
          <p>
            Are you sure you want to delete this Automation?
          </p>
          <small><strong>Please type DELETE to confirm</strong></small>
        `,
        inputAttrs: {
          pattern: 'DELETE',
        },
        trapFocus: true,
        type: 'danger',
        hasIcon: true,
        confirmText: 'Yes, Delete Automation',
        cancelText: 'No, keep Automation',
        onConfirm: async () => {
          try {
            await request.delete(`/tasks/${props.automation._id}`)
            success('Your Automation has been deleted')
            await fetchAutomations()
            await fetchStats()
          } catch (ex) {
            error('Your Automation could not be deleted')
          }
        },
      })
    }

    return {
      clone,
      deleteAutomation,
    }
  },
})
</script>

<i18n>
{
  "en": {
    "History": "History",
    "Clone": "Clone",
    "Delete": "Delete"
  },
  "en-US": {
    "History": "History",
    "Clone": "Clone",
    "Delete": "Delete"
  }
}
</i18n>
